export default __webpack_public_path__ + "static/media/TAHOMAB0.fbb77b26.TTF";